import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { LayerContextProvider, layers, Modal, SlideFromTop } from "@activecollab/components";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import { FETCH_TIME_RECORDS_SUCCESS } from "~/store/action_types/index.jsx";
import { fetchParentTimeRecords } from "~/store/actions/actions.timeRecords.jsx";
import { TimeRecordModalContent } from "./TimeRecordModalContent.jsx";
import usePagination from "../Hooks/usePagination.jsx";

export const TimeRecordModalContainer = ({
  children,
  open,
  onClose,
  bodyClassName,
  parentType,
  parentId,
  from,
  to,
  projectId,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState();

  const handleAction = useCallback((action) => {
    if (action.type === FETCH_TIME_RECORDS_SUCCESS) {
      setHeaders(action.responseHeaders ? action.responseHeaders : {});
    }
  }, []);

  const pagination = usePagination(headers);

  const getTimeRecords = useCallback(
    async (cursor) => {
      if (!parentType || !parentId) {
        return;
      }

      let query = {};
      if (cursor) {
        query = { ...query, cursor };
      }
      if (from && to) {
        query = { ...query, from, to };
      }
      const action = await dispatch(fetchParentTimeRecords(parentType, parentId, projectId, query));
      setLoading(false);
      handleAction(action);
    },
    [parentType, parentId, from, to, dispatch, projectId, handleAction]
  );

  const handleFetchMore = useCallback(() => {
    if (pagination?.cursor && !loading) {
      setLoading(true);
      getTimeRecords(pagination.cursor);
    }
  }, [pagination.cursor, loading, getTimeRecords]);

  useEffect(() => {
    if (open) {
      getTimeRecords();
    }
  }, [getTimeRecords, open]);

  const paginationDate = pagination.cursor ? moment.utc(pagination.cursor).unix() : undefined;

  return (
    <LayerContextProvider value={{ zIndex: layers.skyscraper }}>
      <Modal
        open={open}
        onClose={onClose}
      >
        <SlideFromTop in={open}>
          <div className={classNames("time_record_modal_wrapper", bodyClassName)}>
            <TimeRecordModalContent
              isLoadingMore={loading}
              showLimitedAccess={!pagination?.cursor}
              handleFetchMore={handleFetchMore}
              paginationDate={paginationDate}
            >
              {children}
            </TimeRecordModalContent>
          </div>
        </SlideFromTop>
      </Modal>
    </LayerContextProvider>
  );
};

TimeRecordModalContainer.propTypes = {
  projectId: PropTypes.number.isRequired,
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  bodyClassName: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.any,
};

TimeRecordModalContainer.defaultProps = {
  open: false,
  bodyClassName: "",
};
